import { createSelector } from '@ngrx/store'
import { RootState } from '../../root.model'
import { ExternalTransactionRedux } from './external-transaction.reducer'

const selectExternalTransaction = (state: RootState) =>
  state.panels.externalTransactions

/**
 * Get selected external transactions.
 */
export const selectExternalTransactions = createSelector(
  selectExternalTransaction,
  (state: ExternalTransactionRedux) => state.externalTransactions,
)
